import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Link, useParams } from 'react-router-dom';
import { useExpiredlink, useResetPass } from './api/apiAuthentication';
import { CircularProgress } from '@mui/material';
import lock from '../assets/images/icons/lock.svg'
import eyeslash from '../assets/images/icons/eye-slash.svg'
import eye from '../assets/images/icons/eye.svg'
import logocolor from '../assets/images/logo.png'

const schema = yup.object().shape({
    newPassword: yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]{6,30}$/, 'Password must contain at least one uppercase letter, one lowercase letter, one number and one special character')
        .max(30, 'Password must be at most 30 characters')
        .required('Password is Required'),
    confirmNewPassword: yup.string()
        .oneOf([yup.ref('newPassword'), null], "Confirm Password doesn't match")
        .required('Confirm Password is Required'),
})

const ResetPassword = () => {

    const resetPasswordmutation = useResetPass()

    const params = useParams()
    const link = params?.id || ''

    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            newPassword: "",
            confirmNewPassword: "",
        }
    });

    const { mutate: checkUrl } = useExpiredlink()
    useEffect(() => {
        checkUrl({ "token": link, url: 'reset-password' });
    }, [checkUrl, link]);

    const onSubmit = async (data) => {
        const sendObj = {
            "password": data.newPassword,
            "confirmPassword": data.confirmNewPassword,
            'token': link
        }
        const res = await resetPasswordmutation.mutateAsync(sendObj)

        if (res) reset()
    }

    const [inputType, setInputType] = useState({
        NewPw: true,
        ConfirmPw: true,
    });

    const handleInputChange = (paramName, value) => {
        setInputType((prevParams) => (
            {
                ...prevParams,
                [paramName]: value,
            }));
    };



    return (

        <div className='LoginRegBg'>
            <div className='crPg-bg-color crPg-bg-image'>
                <section>
                    <div className="container">
                        <div className="row align-items-center justify-content-center min-vh-100 py-4">
                            <div className="col">
                                <div className="crPgBr mx-438">
                                    <div className="crPg">

                                        <div className="crPgFrm crPgFrmIps">
                                            <div className="crPgLogo text-center mx-438">
                                                <img src={logocolor} className='img-fluid' alt="Logo" />

                                            </div>
                                            <div className="crPgWclTx crPgWcl-tx-color pb-4 mb-2">
                                                <h1>Reset Password</h1>
                                                <p>Enter your password to access the admin.</p>
                                            </div>

                                            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                                <div className="input-group mb-3">
                                                    <span className="input-group-icon">
                                                        <img src={lock} className='img-fluid' alt="lock" />
                                                    </span>
                                                    <Controller name='newPassword' control={control} render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            type={inputType.NewPw ? "password" : "text"}
                                                            className="form-control"
                                                            disabled={resetPasswordmutation.isLoading}
                                                            placeholder='Enter your new password'
                                                            autoComplete='off'
                                                        />
                                                    )} />

                                                    <button type="button" onClick={() => handleInputChange('NewPw', !inputType.NewPw)} className={`btn p-0 input-group-icon border-0 shwPwd ${inputType.NewPw ? "" : "show-eye"}`.trim()} >
                                                        <img src={eyeslash} className='img-fluid eye-hide' alt="eye-slash" />
                                                        <img src={eye} className='img-fluid eye-show' alt="eye" />
                                                    </button>
                                                </div>
                                                {errors.newPassword && <p className="errMsg">* {errors.newPassword.message}</p>}
                                                <div className="input-group mb-3">
                                                    <span className="input-group-icon">
                                                        <img src={lock} className='img-fluid' alt="lock" />
                                                    </span>
                                                    <Controller name='confirmNewPassword' control={control} render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            type={inputType.ConfirmPw ? "password" : "text"}
                                                            className="form-control"
                                                            disabled={resetPasswordmutation.isLoading}
                                                            id="inputconfirmpw" placeholder="Enter your confirm password"
                                                            autoComplete='off'
                                                        />
                                                    )} />

                                                    <button type="button" onClick={() => handleInputChange('ConfirmPw', !inputType.ConfirmPw)} className={`btn p-0 input-group-icon border-0 shwPwd ${inputType.ConfirmPw ? "" : "show-eye"}`.trim()} >
                                                        <img src={eyeslash} className='img-fluid eye-hide' alt="eye-slash" />
                                                        <img src={eye} className='img-fluid eye-show' alt="eye" />
                                                    </button>
                                                </div>
                                                {errors.confirmNewPassword && <p className="errMsg">* {errors.confirmNewPassword.message}</p>}
                                                <div className="d-grid crPgbtn pt-2">
                                                    <button className="btn btn-primary" disabled={resetPasswordmutation.isLoading}>
                                                        {resetPasswordmutation.isLoading ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Reset Password"}
                                                    </button>
                                                </div>
                                                <div className='fgtLks text-center mt-2 BacktoLogin'>
                                                    <p>Back to <Link to="/">Login</Link></p>
                                                </div>
                                            </form>



                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    )
}
export default ResetPassword;